import { useContext } from 'react'
import { PreOrderCartContext } from '../context'

export function usePreOrderCart() {
  const ctx = useContext(PreOrderCartContext)
  if (ctx === undefined) throw new Error('usePreOrderCart must be used within a PreOrderCartProvider')
  return ctx
}
